import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    Card, CardHeader, CardBody,
    Form, FormGroup, Label, Input, Button,
    Container, Row, Col
} from "reactstrap";
import Swal from "sweetalert2"

 const cardShell = {
        background: "var(--vz-secondary-bg, #fff)",
        border: "1px solid var(--vz-border-color)",
        borderRadius: 10,
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        overflow: "hidden",
    };


function EditAsset() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        category: "",
        description: "",
        department: "",
        segments: "",
        specification: "",
        criticality: "",
        internal_external: "",
        value: ""
    });

    useEffect(() => {
        const fetchAsset = async () => {
            try {
                const authUser = JSON.parse(sessionStorage.getItem("authUser"));
                const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/assets/assetdetails/${id}`, {
                    headers: {
                        "Content-Type": "application/json",
                        ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
                    },
                });
                const data = await res.json();
                if (data.success) {
                    setFormData(data.asset); // pre-fill form
                }
            } catch (err) {
                console.error("Error fetching asset:", err);
            }
        };
        fetchAsset();
    }, [id]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const authUser = JSON.parse(sessionStorage.getItem("authUser"));
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/assets/assetdetails/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
                },
                body: JSON.stringify(formData),
            });
            const data = await res.json();
            if (data.success) {
                Swal.fire("Updated!", "Asset details have been saved.", "success");
                navigate("/AssetManagement");
            } else {
                Swal.fire("Error", data.error || "Update failed", "error");
            }

        } catch (err) {
            console.error("Error updating asset:", err);
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <Card style={cardShell}>
                    <CardHeader className="bg-primary">
                        <h4 className="mb-0 text-white">Edit Asset</h4>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="name">Asset Name</Label>
                                        <Input id="name" name="name" type="text"
                                            value={formData.name || ""} onChange={handleChange} required />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="category">Category</Label>
                                        <Input id="category" name="category" type="text"
                                            value={formData.category || ""} onChange={handleChange} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="department">Department</Label>
                                        <Input id="department" name="department" type="text"
                                            value={formData.department || ""} onChange={handleChange} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="segments">Segments</Label>
                                        <Input id="segments" name="segments" type="text"
                                            value={formData.segments || ""} onChange={handleChange} />
                                    </FormGroup>
                                </Col>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="description">Description</Label>
                                        <Input id="description" name="description" type="textarea"
                                            value={formData.description || ""} onChange={handleChange} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="specification">Specification</Label>
                                        <Input id="specification" name="specification" type="text"
                                            value={formData.specification || ""} onChange={handleChange} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="criticality">Criticality</Label>
                                        <Input id="criticality" name="criticality" type="select"
                                            value={formData.criticality || ""} onChange={handleChange}>
                                            <option value="">Select</option>
                                            <option value="Low">Low</option>
                                            <option value="Medium">Medium</option>
                                            <option value="High">High</option>
                                            <option value="Critical">Critical</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="internal_external">Internal/External</Label>
                                        <Input id="internal_external" name="internal_external" type="select"
                                            value={formData.internal_external || ""} onChange={handleChange}>
                                            <option value="">Select</option>
                                            <option value="Internal">Internal</option>
                                            <option value="External">External</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="value">Value</Label>
                                        <Input id="value" name="value" type="number"
                                            value={formData.value || ""} onChange={handleChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-center gap-5">
                                <Button type="submit" color="warning">Update Asset</Button>
                                <Button type="button" color="secondary" onClick={() => navigate("/AssetManagement")}>Cancel</Button>
                            </div>
                        </Form>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
}

export default EditAsset;
